import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchCropField(agro_exporter_id, crop_field_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/list_templates/${agro_exporter_id}/crop_field/${crop_field_id}`
    );
  },
  fetchTemplates(agro_exporter_id, crop_field_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/list_templates/${agro_exporter_id}/${crop_field_id}`
    );
  },
};
